<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-03-07 14:01:01
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\Approval\viewApproval.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_approvalTemplate_form_editTitle')
        : $t('label_essweb_approvalTemplate_form_viewTitle')
    "
    pad="0"
    widthClass="max-1000"
    :delBtn="hasBtn('delete-admin-approval-template')"
    :initData="approvalData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'flow_template_status',
      'flow_template_name',
      'flow_template_description',
      'flow_type_uuid',
      'flow_template_code',
      'business_data_table_name',
      'effective_utc_datetime',
      'expired_utc_datetime',
      'remarks',
    ]"
    :editBtn="!iSEdited && hasBtn('edit-admin-approval-template')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_approvalTemplate_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-switch
                  color="primary"
                  class="ml-4"
                  :disabled="!iSEdited"
                  v-model="approvalData.flow_template_status"
                  :label="
                    approvalData.flow_template_status
                      ? $t('label_essweb_approvalTemplate_form_activeLabel')
                      : ''
                  "
                ></v-switch>
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="approvalData.flow_template_name"
                  @change="
                    (valueArr) => {
                      approvalData.flow_template_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_approvalTemplateNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="approvalData.flow_template_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="approvalData.flow_template_description"
                  @change="
                    (valueArr) => {
                      approvalData.flow_template_description = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_approvalTemplate_form_descriptionLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t(
                    "label_essweb_approvalTemplate_form_approvalTemplateTypeLabel"
                  )
                }}</v-sheet>
                <v-autocomplete
                  :items="approvalType"
                  item-text="flow_type_name"
                  item-value="uuid"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  single-line
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="approvalData.flow_type_uuid"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_approvalTemplateTypeLabel'
                    )
                  "
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>

              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_tableNameLabel")
                }}</v-sheet>
                <v-autocomplete
                  single-line
                  dense
                  disabled
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  v-model="approvalData.business_data_table_name"
                  :filled="iSEdited"
                  item-text="view_fields"
                  item-value="value_field"
                  :placeholder="
                    $t('label_essweb_approvalTemplate_form_tableNameLabel')
                  "
                  :items="Tables"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                >
                  <template v-slot:no-data> <noContent /> </template>
                  <template v-slot:selection="data">
                    {{ $getCommonLangValue(data.item.view_fields) }}
                  </template>
                  <template v-slot:item="data">
                    <div class="table-title text--primary">
                      {{ $getCommonLangValue(data.item.view_fields) }}
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <DateTimePicker
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  type="date"
                  :defaultTime="approvalData.effective_utc_datetime"
                  :filled="iSEdited"
                  :label="
                    $t('label_essweb_approvalTemplate_form_effectiveDateLabel')
                  "
                  :readonly="!iSEdited"
                  placeholder="YYYY/MM/DD"
                  :max="approvalData.expired_utc_datetime"
                  @change="
                    (time) => {
                      approvalData.effective_utc_datetime = time;
                    }
                  "
                ></DateTimePicker>
              </v-col>
              <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
                <v-sheet class="text--secondary">Time Zone</v-sheet>
                <v-autocomplete
                  single-line
                  dense
                  v-model="approvalData.effective_time_zone"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                >   <template v-slot:no-data>
                <noContent />
              </template></v-autocomplete>
              </v-col>-->
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <DateTimePicker
                  :min="approvalData.effective_utc_datetime"
                  type="date"
                  :defaultTime="approvalData.expired_utc_datetime"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :label="
                    $t('label_essweb_approvalTemplate_form_expireDateLabel')
                  "
                  placeholder="YYYY/MM/DD"
                  @change="
                    (time) => {
                      approvalData.expired_utc_datetime = time;
                    }
                  "
                ></DateTimePicker>
              </v-col>
              <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_timeZoneLabel")
                }}</v-sheet>
                <v-select
                  single-line
                  v-model="approvalData.expired_time_zone"
                  dense
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col> -->
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  v-model="approvalData.remarks"
                  dense
                  counter="500"
                  single-line
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <!-- buglist 1495 mel -->
          <!-- <noContent v-if="NodeList.length == 0" /> -->
          <draggable
            v-model="dragArr"
            draggable=".drag"
            :disabled="true"
            class="from_content"
            v-bind="{ animation: 1000 }"
          >
            <!-- :list="NodeList" -->
            <v-sheet
              class="drag transparent d-flex flex-grow-1 ma-3 align-center"
              v-for="(item, index) in NodeList"
              :key="index"
            >
              <v-avatar color="primary  white--text" size="40">
                <span class="headline">{{ item.number + 1 }}</span>
              </v-avatar>
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-card
                  class="
                    white
                    d-flex
                    flex-row
                    justify-space-around
                    flex-grow-1
                    ml-3
                    align-center
                  "
                  :elevation="hover ? 10 : 2"
                  :class="iSEdited ? 'pa-2' : 'pa-4 pl-2'"
                >
                  <!--  buglist 1495 -->
                  <!-- <div>
                    <svg-icon size="36" fill="grey" iconClass="dragvertical" />
                  </div> -->
                  <span>
                    {{ $getCommonLangValue(item.flow_template_node_name) }}
                  </span>
                  <v-spacer></v-spacer>
                  <div v-if="hover">
                    <v-btn
                      icon
                      small
                      v-if="!iSEdited"
                      class="mx-2"
                      @click="
                        curNodeUuid = item.uuid;
                        showViewApprovalDialog = true;
                      "
                    >
                      <svg-icon
                        size="24"
                        fill="currentColor"
                        iconClass="viewDetail"
                      />
                    </v-btn>
                    <v-btn
                      icon
                      small
                      v-if="iSEdited"
                      class="mx-2"
                      @click="
                        curNodeUuid = item.uuid;
                        showEditApprovalDialog = true;
                        curNumber = item.number;
                      "
                    >
                      <span class="material-icons-round">edit</span>
                    </v-btn>
                    <v-btn
                      icon
                      v-if="iSEdited"
                      small
                      class="mx-2"
                      @click="toDeleteNode(item.uuid)"
                    >
                      <span class="material-icons-round">delete</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-hover>
            </v-sheet>
          </draggable>
          <v-btn
            text
            v-if="iSEdited"
            color="primary"
            small
            @click="showNewApprovalDialog = true"
            class="text-capitalize"
          >
            <span class="material-icons-round">add</span
            >{{ $t("label_essweb_approvalTemplate_form_node_addNodeBtnLabel") }}
          </v-btn>
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <template v-slot:tools-main>
      <newApprovalDialog
        :show="showNewApprovalDialog"
        @close="
          showNewApprovalDialog = false;
          NodePropertyData = null;
        "
        :allNode="NodeList"
        @onNew="onNewNode"
        :table="approvalData.business_data_table_name"
      />
      <editApprovalDialog
        :show="showEditApprovalDialog"
        @close="
          showEditApprovalDialog = false;
          NodePropertyData = null;
          curNodeUuid = null;
          curNumber = null;
        "
        :allNode="NodeList.filter((ele) => ele['number'] <= Number(curNumber))"
        :PropertyData="NodePropertyData"
        @onEdit="onEditNode"
        :curUuid="curNodeUuid"
        :table="approvalData.business_data_table_name"
      />
      <viewApprovalDialog
        :show="showViewApprovalDialog"
        @close="
          showViewApprovalDialog = false;
          NodePropertyData = null;
          curNodeUuid = null;
        "
        :allNode="NodeList"
        :PropertyData="NodePropertyData"
        @onEdit="onEditNode"
        :curUuid="curNodeUuid"
        :table="approvalData.business_data_table_name"
      />
    </template>
  </ContentLayout>
</template>
<script>
import newApprovalDialog from "@/Page/EssAdmin/Approval/Approval/components/newApprovalDialog_online.vue";
import editApprovalDialog from "@/Page/EssAdmin/Approval/Approval/components/editApprovalDialog_online.vue";
import viewApprovalDialog from "@/Page/EssAdmin/Approval/Approval/components/viewApprovalDialog.vue";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  name: "",
  components: {
    newApprovalDialog,
    draggable,
    editApprovalDialog,
    viewApprovalDialog,
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
  },
  data() {
    return {
      curTab: "tab-1",
      isChanged: false,
      taber: [
        "label_essweb_approvalTemplate_form_step_generalLabel",
        "label_essweb_approvalTemplate_form_step_addNodeLabel",
      ],
      iSEdited: false,
      showNewApprovalDialog: false,
      NodePropertyData: null,
      showViewApprovalDialog: false,
      showEditApprovalDialog: false,
      dragArr: [],
      curNumber: null,
      curNumber: null,
      curNodeUuid: null,
      NodeList: [],
      Tables: [],
      approvalType: [],
      approvalData: {
        flow_template_status: 0,
        flow_template_name: "",
        flow_template_code: "",
        flow_template_description: "",
        flow_type_uuid: "",
        business_data_table_name: "",
        effective_utc_datetime: "",
        effective_time_zone: 0,
        expired_utc_datetime: "",
        expired_time_zone: 0,
        remarks: "",
      },
    };
  },
  mounted() {
    this.approvalData.effective_time_zone = this.defaultUTC;
    this.approvalData.expired_time_zone = this.defaultUTC;
    this.getBtnPermissionList();
    this.getApprovalType();
    this.getTableName();
    this.getDetail();
    this.getNodeList();
  },
  methods: {
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/get-approval-template-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["flow_template_name_save"] = res.data.flow_template_name;
        res.data.flow_template_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.flow_template_name
        );
        res.data["flow_template_description_save"] =
          res.data.flow_template_description;
        res.data.flow_template_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.flow_template_description
        );
        res.data.flow_template_status = Number(res.data.flow_template_status);
        res.data.effective_utc_datetime = that.$getDateTime(
          res.data.effective_utc_datetime,
          "YYYY-MM-DD"
        );
        res.data.expired_utc_datetime = that.$getDateTime(
          res.data.expired_utc_datetime,
          "YYYY-MM-DD"
        );
        that.approvalData = res.data;
      });
    },
    getNodeList: function () {
      const that = this;
      that.NodeList = [];
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_template_nodes",
        url: "/approval-node/get-approval-node-list/",
        data: {
          flow_template_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.map((item, index) => {
          item["number"] = index;
        });
        that.NodeList = res.data;
        that.NodePropertyData = null;
        that.curNodeUuid = null;
        that.curNumber = null;
      });
    },
    getApprovalType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/get-approval-type-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.flow_type_name = that.$getCommonLangValue(item.flow_type_name);
        });
        that.approvalType = res.data;
      });
    },
    getTableName: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_approval_business_table_select",
        table_type: 1,
      }).then((res) => {
        that.Tables = res.data;
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },

    toDeleteNode: function (uuid) {
      const that = this;
      this.curNodeUuid = uuid;
      this.$confirmDo(
        this.$t("label_essweb_approvalTemplate_form_nodeLabel")
      ).then((res) => {
        if (res) that.onDeleteNode();
      });
    },
    onDeleteNode: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_template_nodes",
        url: "/approval-node/delete-approval-node-table/",
        data: { uuids: this.curNodeUuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalTemplate_form_deleteNodeSuccessLabel"
          ),
          type: "success",
        });
        that.NodeList = that.NodeList.filter(
          (ele) => ele.uuid == that.curNodeUuid
        );
        that.getNodeList();
      });
    },
    onEditNode: function (obj) {
      const that = this;
      if (
        obj.ess_workflow_template_node_permission[0].pre_node_approver === ""
      ) {
        obj.ess_workflow_template_node_permission[0].pre_node_approver = null;
      }
      if (
        obj.ess_workflow_template_node_permission[0]
          .pre_node_approver_leader === ""
      ) {
        obj.ess_workflow_template_node_permission[0].pre_node_approver_leader =
          null;
      }
      if (
        obj.ess_workflow_template_node_permission[0].cc_pre_node_approver === ""
      ) {
        obj.ess_workflow_template_node_permission[0].cc_pre_node_approver =
          null;
      }
      if (
        obj.ess_workflow_template_node_permission[0]
          .cc_pre_node_approver_leader === ""
      ) {
        obj.ess_workflow_template_node_permission[0].cc_pre_node_approver_leader =
          null;
      }
      this.showEditApprovalDialog = false;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_template_nodes",
        url: "/approval-node/update-approval-node-table/",
        data: {
          approver_notify_threshold: obj.approver_notify_threshold,
          uuid: this.curNodeUuid,
          flow_template_node_name: obj.flow_template_node_name,
          flow_template_node_description: obj.flow_template_node_description,
          is_allow_forward: obj.is_allow_forward,
          is_allow_revoke: obj.is_allow_revoke,
          is_allow_rollback: obj.is_allow_rollback,
          is_first_sequence: obj.is_first_sequence,
          is_allow_skip: obj.is_allow_skip,
          is_allow_view_attachments: obj.is_allow_view_attachments,
          is_final_sequence: obj.is_final_sequence,
          is_alert_notification: obj.is_alert_notification,
          // 2021-01-11 改为一个通知 brain
          // is_alert_notification: obj.is_alert_notification,
          // is_alert_prev_approver: obj.is_alert_prev_approver,
          ess_workflow_template_node_allow_update_fields:
            obj.ess_workflow_template_node_allow_update_fields,
          ess_workflow_template_node_permission:
            obj.ess_workflow_template_node_permission,
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.getNodeList();
      });
    },
    onNewNode: function (obj) {
      const that = this;
      this.showNewApprovalDialog = false;
      if (
        obj.ess_workflow_template_node_permission[0].pre_node_approver === ""
      ) {
        obj.ess_workflow_template_node_permission[0].pre_node_approver = null;
      }
      if (
        obj.ess_workflow_template_node_permission[0]
          .pre_node_approver_leader === ""
      ) {
        obj.ess_workflow_template_node_permission[0].pre_node_approver_leader =
          null;
      }
      if (
        obj.ess_workflow_template_node_permission[0].cc_pre_node_approver === ""
      ) {
        obj.ess_workflow_template_node_permission[0].cc_pre_node_approver =
          null;
      }
      if (
        obj.ess_workflow_template_node_permission[0]
          .cc_pre_node_approver_leader === ""
      ) {
        obj.ess_workflow_template_node_permission[0].cc_pre_node_approver_leader =
          null;
      }
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_template_nodes",
        url: "/approval-node/add-approval-node-table/",
        data: {
          approver_notify_threshold: obj.approver_notify_threshold,
          flow_template_uuid: this.$route.params.id,
          flow_template_node_name: obj.flow_template_node_name,
          flow_template_node_description: obj.flow_template_node_description,
          is_allow_forward: obj.is_allow_forward,
          is_allow_skip: obj.is_allow_skip,
          is_allow_revoke: obj.is_allow_revoke,
          is_allow_rollback: obj.is_allow_rollback,
          is_first_sequence: this.NodeList.length > 0 ? 0 : 1,
          is_final_sequence: this.NodeList.length > 0 ? 1 : 0,
          is_alert_notification: obj.is_alert_notification,
          // 2021-01-11 改为一个通知 brain
          // is_alert_notification: ois_is_alert_notificationant,
          // is_alert_prev_approver: obj.is_alert_prev_approver,
          ess_workflow_template_node_allow_update_fields:
            obj.ess_workflow_template_node_allow_update_fields,
          ess_workflow_template_node_permission:
            obj.ess_workflow_template_node_permission,
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.getNodeList();
      });
    },
    toSave: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/update-approval-template-table/",
        data: {
          uuid: this.$route.params.id,
          flow_template_name: this.$transCommonLangKey(
            this.approvalData.flow_template_name,
            this.approvalData.flow_template_name_save
          ),
          flow_template_code: this.approvalData.flow_template_code,
          flow_template_description: this.$transCommonLangKey(
            this.approvalData.flow_template_description,
            this.approvalData.flow_template_description_save
          ),
          flow_template_status: this.approvalData.flow_template_status ? 1 : 0,
          flow_type_uuid: this.approvalData.flow_type_uuid,
          // business_data_table_name: this.approvalData.business_data_table_name,
          effective_utc_datetime: this.$getTimeValue(
            this.approvalData.effective_utc_datetime
          ),
          // effective_time_zone: this.approvalData.expired_time_zone,//BJ
          expired_utc_datetime: this.$getTimeValue(
            this.approvalData.expired_utc_datetime
          ),
          // expired_time_zone: this.approvalData.expired_time_zone,//BJ
          remarks: this.approvalData.remarks,
        },
      }).then((res) => {
        that.toBack();
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalTemplate_form_updateSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/delete-approval-template-table/",
        data: { uuids: that.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalTemplate_form_deleteTemplateSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
